export interface ISupport {
  id?: string;
  nfc1?: string | null;
  nfc2?: string | null;
  nfc3?: string | null;
  qrcode?: string | null;
  activated?: boolean | null;
}

export const defaultValue: Readonly<ISupport> = {
  activated: false,
};
